export function getMailBody() {
  return (
    "Please describe on this email Reason of your request: %0D%0A" +
    " - Disagreement on Sales Credit %0D%0A" +
    " - Disagreement on CVA %0D%0A" +
    " - Disagreement on Fees %0D%0A" +
    " - Disagreement on Sales Benef/Author %0D%0A" +
    " - Disagreement on Client %0D%0A" +
    " - Disagreement on Market Data %0D%0A" +
    " - IT issue %0D%0A" +
    " - Reporting issue %0D%0A" +
    " - Deal(s) missing %0D%0A" +
    " - Reference of deals if missing (mandatory) or amount of SC erroneous (Print screen if possible) %0D%0A" +
    " - All other information helping to analyze the issue (Date, client, product, deal type...) %0D%0A"
  );
}
